import { render, staticRenderFns } from "./modalAddAdvertisementMediaAttributes.vue?vue&type=template&id=210afbfb&"
import script from "./modalAddAdvertisementMediaAttributes.vue?vue&type=script&lang=js&"
export * from "./modalAddAdvertisementMediaAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports